"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGetGroupedProduct = require("./useGetGroupedProduct");
Object.keys(_useGetGroupedProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetGroupedProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetGroupedProduct[key];
    }
  });
});